import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { populationsApi } from '@/lib/api'

interface PublishConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  audienceId: string
  audienceName: string
  onConfirm: () => void
}

export default function PublishConfirmDialog({
  open,
  onOpenChange,
  audienceId,
  audienceName,
  onConfirm,
}: PublishConfirmDialogProps) {
  const { t } = useTranslation('app')
  const [creditCost, setCreditCost] = useState<number | null>(null)

  useEffect(() => {
    if (!open || !audienceId) return
    let cancelled = false
    populationsApi
      .getMarketplaceCreditCost(audienceId)
      .then((res) => { if (!cancelled) setCreditCost(res.credits) })
      .catch(() => { if (!cancelled) setCreditCost(null) })
    return () => { cancelled = true }
  }, [open, audienceId])

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('audienceActions.publishQ')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            The audience <strong>{audienceName}</strong> will be published to the
            marketplace where everyone using Fairgen will have access to it.
            {creditCost != null && creditCost > 0 && (
              <>
                {' '}This will refund{' '}
                <strong>{creditCost} credits</strong> to your account.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            variant="cta"
            shape="pill"
            onClick={onConfirm}
          >
            {t('audienceActions.publish')}
          </AlertDialogAction>
          <AlertDialogCancel className="rounded-full">{t('cancel', { ns: 'common' })}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
